import { AmountType } from '../enums/AmountType';

// Array.find amount of certain AmountType
export const ofAmountType = (type: AmountType) => (amount: { amountType: AmountType }) =>
  amount && amount.amountType === type;
